import { z } from 'zod/v3';
import { createPaginationSchema } from '../../common/utils/schema';

export const PermissionSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  checkScope: z.boolean(),
});

export const PermissionPageSchema = createPaginationSchema(PermissionSchema);

export const PermissionOptionSchema = PermissionSchema.transform((item) => ({
  value: item.name,
  label: item.name,
  item: item,
}));

export const PermissionOptionsPageSchema = createPaginationSchema(
  PermissionOptionSchema,
);
